export default __webpack_public_path__ + "89793a1fa13783736b2fe00d2957b09a.svg";